import { TextField, Stack, Button } from '@material-ui/core';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { signIn } from '../../../api_helper/api';
import SnackbarAlertContext from '../../../context/SnackbarAlertContext';
import { trackEvent } from '../../../utils/eventTracking';
import { jwtDecode } from 'jwt-decode';

const signInSchema = z.object({
	email: z.string().min(1, 'Email is required'),
	password: z.string().min(1, 'Password is required'),
});

const SignInForm = ({ onSuccess }) => {
	const { register, formState, handleSubmit } = useForm({ resolver: zodResolver(signInSchema), mode: 'all' });

	const snackbarAlertContext = useContext(SnackbarAlertContext);

	const [isLoading, setIsLoading] = useState(false);

	const formSubmitHandler = async (data) => {
		try {
			setIsLoading(true);

			const { email, password } = data;

			const res = await signIn({ email, password });

			if (!res.data.token) {
				throw new Error(res.data.msg);
			}

			trackEvent({
				userDetails: { userId: jwtDecode(res.data.token).sub, email },
				eventDetails: {
					types: ['KissMetrics', 'Segment', 'AppInsights', 'GA4'],
					eventName: 'WebApp_User signed in to their account.',
				},
			});

			onSuccess(res.data);
		} catch (error) {
			snackbarAlertContext.setSnackbarAlert({
				isSnackbarOpen: true,
				autoHide: 3000,
				msg: error.message || 'There was an error signing in. Please try again later.',
				severity: 'error',
			});
		}

		setIsLoading(false);
	};

	return (
		<form onSubmit={handleSubmit(formSubmitHandler)}>
			<Stack sx={{ gap: 2 }}>
				<TextField
					{...register('email')}
					label="Email"
					error={!!formState.errors.email}
					helperText={formState.errors.email?.message}
					disabled={isLoading}
				/>

				<TextField
					{...register('password')}
					label="Password"
					type="password"
					error={!!formState.errors.password}
					helperText={formState.errors.password?.message}
					disabled={isLoading}
				/>
			</Stack>

			<Button variant="contained" color="primary" type="submit" fullWidth disabled={isLoading} sx={{ mt: 2 }}>
				Sign In & Add DataSpace
			</Button>
		</form>
	);
};

export default SignInForm;
